function toggleCustomizationOptions(radio) {
    var customizationContainer = document.getElementById('customNameNumberContainer');
    var captainInlineLabel = document.getElementById('captainInlineLabel');
    // Show fields only when selecting Name + number option from variants
    var shouldShow = (radio.value === 'Nimi ja numero' || radio.value === 'Name and number') && radio.checked;
  
    // Toggle the display of the customization options
    customizationContainer.style.display = shouldShow ? 'block' : 'none';
    
    // If not shown, clear the inputs
    if (!shouldShow) {
      document.getElementById('customNameInput').value = '';
      document.getElementById('customNumberInput').value = '';
      // Clear hidden properties when customization is off
      // Hidden inputs removed; properties now bind directly via form field names
      updateJerseyPreview(); // Update preview to clear any text
    }
    
    // Add event listeners to your name and number input fields
    document.getElementById('customNameInput').addEventListener('input', updateJerseyPreview);
    document.getElementById('customNumberInput').addEventListener('input', updateJerseyPreview);
    
    // Show captain dropdown only when customization is on
    var captainSelect = document.getElementById('captainSelect');
    if (captainSelect) {
      // Captain stays hidden by default until user clicks the Kapteeninmerkki pill
      captainSelect.style.display = 'none';
      captainSelect.classList.remove('is-active');
      // Prevent submitting a stale selection when hidden
      captainSelect.disabled = true;
      try { captainSelect.selectedIndex = 0; } catch (e) {}
      var hiddenCaptain = document.getElementById('CaptainInputProperty');
      if (hiddenCaptain) hiddenCaptain.value = '';
      captainSelect.classList.add('is-placeholder');
    }
    if (captainInlineLabel) {
      captainInlineLabel.style.display = shouldShow ? 'inline-block' : 'none';
      captainInlineLabel.classList.remove('is-selected');
    }

    validateCustomization(); // Check initial state
}
  
function updateJerseyPreview() {
    var nameInput = document.getElementById('customNameInput');
    var numberInput = document.getElementById('customNumberInput');
    var captainSelect = document.getElementById('captainSelect');

    if (nameInput) {
        // Allow letters (A–Z, ÅÄÖ), dot (.), Space ( ) and hyphen (-), strip everything else
        nameInput.value = nameInput.value.replace(/[^a-zA-ZåäöÅÄÖ\- .]/g, '').toUpperCase();
    }
    
    if (numberInput) {
        // If more than two digits are input, truncate the value
        if (numberInput.value.length > 2) {
            numberInput.value = numberInput.value.slice(0, 2);
        }
    }
    
    // Update the jersey preview
    var jerseyName = document.getElementById('jerseyName');
    var jerseyNumber = document.getElementById('jerseyNumber');
    
    if (jerseyName && nameInput) {
        jerseyName.textContent = nameInput.value;
    }
    if (jerseyNumber && numberInput) {
        jerseyNumber.textContent = numberInput.value;
    }
    
    // Captain badge selection is for cart data only - no visual display on jersey
    
    // Update hidden properties if they exist
    // Hidden property mirrors removed; form fields submit directly
    
    validateCustomization(); // Check validation after any updates
}

function updateCaptainSelection(radio) {
    var selectedValueSpan = document.getElementById('captainSelectedValue');
    var labelText = '';
    
    switch(radio.value) {
        case '':
            labelText = 'Ei';
            break;
        case 'C':
            labelText = 'Kapteeni';
            break;
        case 'A':
            labelText = 'Varakapteeni';
            break;
    }
    
    if (selectedValueSpan) {
        selectedValueSpan.textContent = labelText;
    }
}

function validateCustomization() {
    var addToCartButton = document.querySelector('button[name="add"]');
    if (!addToCartButton) {
        console.error('Add to cart button not found');
        return;
    }
    
    // Check for both Finnish and English variants, and KAPTEENINMERKKI
    var customizationRadio = document.querySelector('input[value="Nimi ja numero"], input[value="Name and number"], input[value="KAPTEENINMERKKI"]');
    var nameInput = document.getElementById('customNameInput');
    var numberInput = document.getElementById('customNumberInput');
    
    if (customizationRadio && customizationRadio.checked) {
        // Disable button if either field is empty when customization is selected
        var isValid = nameInput.value.trim() !== '' && numberInput.value.trim() !== '';
        
        if (!isValid) {
            addToCartButton.setAttribute('aria-disabled', 'true');
            addToCartButton.classList.add('disabled');
        } else {
            addToCartButton.setAttribute('aria-disabled', 'false');
            addToCartButton.classList.remove('disabled');
        }
    } else {
        // Enable button if customization is not selected
        addToCartButton.setAttribute('aria-disabled', 'false');
        addToCartButton.classList.remove('disabled');
    }
}

document.addEventListener('DOMContentLoaded', function() {
    // Initialize event listeners
    if (document.querySelector('input[value="Nimi ja numero"], input[value="Name and number"], input[value="KAPTEENINMERKKI"]')) {
        document.getElementById('customNameInput').addEventListener('input', updateJerseyPreview);
        document.getElementById('customNumberInput').addEventListener('input', updateJerseyPreview);
        validateCustomization(); // Initial check
    }
    
    // Add captain radio button listeners (always available)
    // Captain dropdown change mirrors to hidden input
    var captainSelectInit = document.getElementById('captainSelect');
    if (captainSelectInit) {
        // Initialize placeholder color state
        if (captainSelectInit.selectedIndex === 0 || !captainSelectInit.value) {
          captainSelectInit.classList.add('is-placeholder');
        } else {
          captainSelectInit.classList.remove('is-placeholder');
        }
        captainSelectInit.addEventListener('change', function(){
            // Toggle placeholder style
            var isPlaceholder = (this.selectedIndex === 0 || this.value === '');
            this.classList.toggle('is-placeholder', isPlaceholder);
            // No hidden mirror; property posts directly
            updateJerseyPreview();
        });
    }

    // Make Kapteeninmerkki pill clickable to toggle dropdown when Painatus is active
    var captainInlineLabel = document.getElementById('captainInlineLabel');
    if (captainInlineLabel) {
        var toggleCaptainUI = function(){
            var customizationContainer = document.getElementById('customNameNumberContainer');
            var captainSelect = document.getElementById('captainSelect');
            // Only allow open if Painatus is Name & number (container visible)
            var isPainatusActive = customizationContainer && customizationContainer.style.display !== 'none';
            if (!isPainatusActive) return;
            if (captainSelect) {
                var isVisible = captainSelect.style.display !== 'none';
                captainSelect.style.display = isVisible ? 'none' : 'inline-block';
                captainSelect.disabled = isVisible; // disable when hidden
                if (isVisible) {
                  try { captainSelect.selectedIndex = 0; } catch (e) {}
                  captainSelect.classList.add('is-placeholder');
                }
                captainInlineLabel.classList.toggle('is-selected', !isVisible);
                captainSelect.classList.toggle('is-active', !isVisible);
                if (!isVisible) captainSelect.focus();
            }
        };
        captainInlineLabel.addEventListener('click', toggleCaptainUI);
        captainInlineLabel.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleCaptainUI(); }});
    }

    // Ensure select is enabled only when a real choice is made
    // Ensure initial hidden captain value is blank
    // No hidden mirrors to initialize
});
  
  